export enum EnumTipoOperando {
  BAS = 1,
  FCN = 2,
  FOD = 3,
  LOG = 4,
  BL = 5,
  AUX = 5
}